import { stringToNumber } from 'common/helpers/numeric'
import { useAppSelector } from 'common/hooks/redux'

import { getIsOptimized } from '../../helpers'
import { useSelectedComponentElement } from '../../hooks'

const PreviewLine = ({ variantId }: { variantId: string }) => {
  const { data: selectedElement } = useSelectedComponentElement()
  const subjectLines = useAppSelector(
    (state) => state.campaignStates.subjectLines
  )

  const isOptimized = getIsOptimized(selectedElement)
  const variant = isOptimized
    ? subjectLines.find((line) => line._id === variantId)
    : selectedElement?.variants?.find(
        (variant) => variant.variant_id === stringToNumber(variantId)
      )
  const variantMergeTagIds = variant?.merge_tag_ids
  let shouldShowPreview = false
  let variantText = variant?.text
  const elementMergeTags = selectedElement?.user_input?.merge_tags

  if (variantMergeTagIds && elementMergeTags) {
    variantMergeTagIds.forEach((mergeTagId) => {
      const mergeTag = elementMergeTags.find((tag) => tag._id === mergeTagId)
      if (
        mergeTag &&
        mergeTag.example_values &&
        mergeTag.example_values.length > 0
      ) {
        const exampleValue = mergeTag.example_values[0]
        const mergeTagCode = mergeTag.code
        if (variantText && mergeTagCode) {
          shouldShowPreview = true
          variantText = variantText.replace(
            mergeTagCode,
            `<span style="border-bottom: 1px dotted; text-decoration-thickness: 1px;">${exampleValue}</span>`
          )
        }
      }
    })
  }

  if (!shouldShowPreview) {
    return null
  }

  return (
    <div className="p-6 bg-gold-40 mt-3 mb-6">
      <h4 className="text-base-700 mb-4 uppercase font-medium">
        Preview line with placeholder
      </h4>
      <p
        className="text-sm text-base-700"
        dangerouslySetInnerHTML={{ __html: variantText || '' }}
      />
    </div>
  )
}

export default PreviewLine
